import { createApp } from 'vue';
import MaterialV3 from '@/components/Material-v3.vue';

createApp( MaterialV3 ).mount( '#app' )
